module.exports = __webpack_public_path__ + "assets/img/ac1.ff5a4d75.png";